/**
 * M.3 — New SharePoint site export target.
 *
 * Operator-only. Delegates to the caller's `onExportToSharePointSite`
 * callback (which wires audit + token plumbing in the SPA). The
 * underlying `exportToSharePointSite` Function-App call lives in
 * `../toSharePointSite.ts`.
 *
 * Why a delegated callback instead of calling the function directly?
 * The bearer token + provisioner URL come from the SPA's auth/config
 * context; targets stay leaf (no React, no MSAL). Phase D
 * (operator pass-through) will wrap this with the modal wizard.
 */

import type { ExportTarget } from './types';

export const sharePointSiteTarget: ExportTarget = {
  id: 'sharepoint-site',
  label: 'New SharePoint site… (operator)',
  isVisible: (env) => env.isOperator && env.sharePointProvisionerWired,
  isEnabled: () => true,
  run: async (site, opts) => {
    if (!opts.onExportToSharePointSite) {
      throw new Error(
        'SharePoint provisioner callback missing — wire onExportToSharePointSite in the parent component.',
      );
    }
    const result = (await opts.onExportToSharePointSite(site)) ?? {};
    const jobId = result.jobId;
    return {
      summary: jobId
        ? `SharePoint site provisioning queued — job ${jobId}.`
        : 'SharePoint site provisioning queued.',
    };
  },
};
